<template>
  <a
    :href="href"
    class="btn btn-primary btn-lg rounded-pill"
    :class="$style.joinButton"
  >
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    isSharpen: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" module>
@import '~@/scripts/pages/onepager/styles/variables-entry';

.joinButton.joinButton {
  font-size: 1.375rem;
  padding: 0.4em 1.7em;

  // font-size: 1.87500rem;
  // padding: 0.5em 3.5em;
}
</style>
